import {
  AddArticle,
  addArticleCategory,
  addArticleGroup,
  AddBbs,
  addBuscard,
  addBuscardCategory,
  addBuscardGroup,
  addCategories,
  addCategory,
  AddDocument,
  addDocumentCategory,
  addDocumentGroup,
  addFile,
  addFolder,
  addGoods,
  addGoodsCategory,
  addGoodsGroup,
  addGroup,
  addHandBookCategory,
  addHandBookGroup,
  AddLocation,
  addNewIcon,
  addNewPic,
  addPosterCategory,
  addPosterGroup,
  addSourceGroup,
  addVideo,
  addVideoCategory,
  addVideoGroup,
  cancelCollect,
  collectFile,
  delArticle,
  delArticleCategory,
  delArticleGroup,
  delBbs,
  delBuscard,
  delBuscardCategory,
  delBuscardGroup,
  delCategories,
  delCategory,
  delComment,
  delDocument,
  delDocumentCategory,
  delDocumentGroup,
  delFile,
  delFolder,
  delFolderGroup,
  delGood,
  delGoodsCategory,
  delGoodsGroup,
  delGroup,
  delGroupes,
  delHandBook,
  delHandBookCategory,
  delHandBookGroup,
  delLocation,
  delPic,
  delPoster,
  delPosterCategory,
  delPosterGroup,
  delSourceGroup,
  delVideo,
  delVideoCategory,
  delVideoGroup,
  editArticle,
  editBuscard,
  editDocument,
  editFile,
  editFolder,
  editGoods,
  editHandBook,
  editLocation,
  editPic,
  editPoster,
  editSourceGroup,
  editVideo,
  editVideoCategory,
  editVideoGroup,
  getAddHandBook,
  getAddPoster,
  getArticle,
  getArticleCategory,
  getArticleDetail,
  getArticleGroup,
  getBbs,
  getBbsDetail,
  getBuscard,
  getBuscardCategory,
  getBuscardDetail,
  getBuscardGroup,
  getCategory,
  getCategoryLists,
  getCollectList,
  getComment,
  getDocument,
  getDocumentCategory,
  getDocumentDetail,
  getDocumentGroup,
  getFileList,
  getFolderDetail,
  getfolderList,
  getGoodDetail,
  getGoods,
  getGoodsCategory,
  getGoodsGroup,
  getGroup,
  getGroupLists,
  getHandBook,
  getHandBookCategory,
  getHandBookDetail,
  getHandBookGroup,
  getIconLists,
  getLocation,
  getLocationDetail,
  getPdfToPisList,
  getPicDetail,
  getPicLists,
  getPoster,
  getPosterCategory,
  getPosterDetail,
  getPosterGroup,
  getSourceGroupList,
  getSysPicLists,
  getVideoCategoryList,
  getVideoDetail,
  getVideoGroupList,
  getVideoList,
  getWebPageList,
  muliteEditSourceGroup,
  pdfToPic,
  postAddGroupes,
  redactArticleCategory,
  redactArticleGroup,
  redactBuscardCategory,
  redactBuscardGroup,
  redactCategorisy,
  redactCategory,
  redactDocumentCategory,
  redactDocumentGroup,
  redactGoodsCategory,
  redactGoodsGroup,
  redactGroup,
  redactGroupes,
  redactHandBookCategory,
  redactHandBookGroup,
  redactPosterCategory,
  redactPosterGroup,
  sortClassType,
  sortGroupType,
  tansferFile,
  tansferToFloder,
  editItemGoods
} from '@/services/sourceapi'

export default {
  state: {
    albumsMenu: [],
    fileMenu: [],
    otherMenu: []
  },
  getters: {},
  mutations: {
    setAlbumsMenu (state, list) {
      state.albumsMenu = list
    },
    setFileMenu (state, list) {
      state.fileMenu = list
    },
    setOtherMenu (state, list) {
      state.otherMenu = list
    }
  },
  actions: {
    addSourceGroup (store, params) {
      return addSourceGroup(params)
    },
    editSourceGroup (store, {id, params}) {
      return editSourceGroup(id, params)
    },
    async getSourceGroupList ({commit}, appId) {
      let params = {
        folderType: 2
      }
      let result = await getSourceGroupList(params)
      if (result.code === 0) {
        let menulists = result.data.map(child => {
          let info = {
            pid: 1,
            id: child.id,
            name: child.name,
            url: '/albplat/' + appId + '/albums/' + child.id,
            uicon: child.icon || require('../../assets/home/ic_goumajilu@2x.png'),
            icon: child.selectedIcon || require('../../assets/home/ic_goumajilu@2x.png'),
            link: '',
            contentFolderType: child.contentFolderType,
            query: {
              folderType: child.contentFolderType
            }
          }
          if (child.link && child.link.link) {
            info.link = child.link.link || ''
          }
          return info
        })
        commit('setAlbumsMenu', menulists)
      }

      let pars = {
        folderType: 3
      }
      let resl = await getSourceGroupList(pars)
      if (resl.code === 0) {
        let fileMenus = resl.data.map(child => {
          let info = {}
          if (child.contentFolderType === 24) {
            info = {
              pid: 3,
              id: child.id,
              name: child.name,
              url: '/albplat/' + appId + '/collections',
              uicon: child.icon || require('../../assets/home/ic_goumajilu@2x.png'),
              icon: child.selectedIcon || require('../../assets/home/ic_goumajilu@2x.png'),
              contentFolderType: child.contentFolderType,
              link: '',
            }
          } else {
            info = {
              pid: 3,
              id: child.id,
              name: child.name,
              url: '/albplat/' + appId + '/albums/' + +child.id,
              uicon: child.icon || require('../../assets/home/ic_goumajilu@2x.png'),
              icon: child.selectedIcon || require('../../assets/home/ic_goumajilu@2x.png'),
              link: '',
              contentFolderType: child.contentFolderType,
              query: {
                folderType: child.contentFolderType
              }
            }
          }
          if (child.link && child.link.link) {
            info.link = child.link.link || ''
          }
          return info
        })
        commit('setFileMenu', fileMenus)
      }
      let pars1 = {
        folderType: 1
      }
      let resls1 = await getSourceGroupList(pars1)
      if (resls1.code === 0) {
        let fileMenus = resls1.data.map(child => {
          let info = {}
          info = {
            pid: 4,
            id: child.id,
            name: child.name,
            url: '/albplat/' + appId + '/disk',
            uicon: child.icon || require('../../assets/home/ic_goumajilu@2x.png'),
            icon: child.selectedIcon || require('../../assets/home/ic_goumajilu@2x.png'),
            link: '',
            contentFolderType: child.contentFolderType,
          }
          if (child.link && child.link.link) {
            info.link = child.link.link || ''
          }
          return info
        })
        commit('setOtherMenu', fileMenus)
      }
    },
    delSourceGroup (store, params) {
      return delSourceGroup(params)
    },
    addPic (store, params) {
      return addPic(params)
    },
    getPicList (store, params) {
      return getPicList(params)
    },
    addVideo (store, params) {
      return addVideo(params)
    },
    addFile (store, params) {
      return addFile(params)
    },
    delFile (store, params) {
      return delFile(params)
    },
    getFileList (store, params) {
      return getFileList(params)
    },
    muliteEditSourceGroup (store, params) {
      return muliteEditSourceGroup(params)
    },
    editFiles (store, {id, params}) {
      return editFile(id, params)
    },
    tansferFile (store, params) {
      return tansferFile(params)
    },
    addFolder (store, params) {
      return addFolder(params)
    },
    getfolderList (store, params) {
      return getfolderList(params)
    },
    editFolders (store, {id, params}) {
      return editFolder(id, params)
    },
    delFolder (store, params) {
      return delFolder(params)
    },
    delFolderGroup (store, params) {
      return delFolderGroup(params)
    },
    getFolderDetail (store, id) {
      return getFolderDetail(id)
    },
    tansferToFloder (store, params) {
      return tansferToFloder(params)
    },
    getCollectList (store, params) {
      return getCollectList(params)
    },
    collectFile (store, params) {
      return collectFile(params)
    },
    cancelCollect (store, params) {
      return cancelCollect(params)
    },
    getWebPageList (store, params) {
      return getWebPageList(params)
    },
    sortClassType (store, params) {
      return sortClassType(params)
    },
    sortGroupType (store, params) {
      return sortGroupType(params)
    },

// ----------------------------图标素材---------------------------------
    getSysPicLists (store, params) {
      return getSysPicLists(params)
    },
    getIconLists (store, params) {
      return getIconLists(params)
    },
    addNewIcon (store, params) {
      return addNewIcon(params)
    },
// ----------------------------图片素材---------------------------------
    // 渲染图片素材列表
    getPicLists (store, params) {
      return getPicLists(params)
    },
    //
    getPicCategoryLists (store, params) {
      return getPicCategoryLists(params)
    },
    // 新添加图片
    addNewPic (store, params) {
      return addNewPic(params)
    },
    // 删除图片素材
    delPic (store, params) {
      return delPic(params)
    },
    // 获取图片详情
    getPicDetail (store, {id, params}) {
      return getPicDetail(id, params)
    },
    // 编辑图片
    editPic (store, {id, params}) {
      return editPic(id, params)
    },
    // 新添加分类
    addCategory (store, params) {
      return addCategory(params)
    },
    // 修改分类
    redactCategory (store, {id, params}) {
      return redactCategory(id, params)
    },
    // 分类删除
    delCategory (store, params) {
      return delCategory(params)
    },
    // 图片分类列表
    getCategoryLists (store, params) {
      return getCategoryLists(params)
    },
    // 新建图片分组
    addGroup (store, params) {
      return addGroup(params)
    },
    // 修改分组
    redactGroup (store, {id, params}) {
      return redactGroup(id, params)
    },
    delGroup (store, params) {
      return delGroup(params)
    },
    // 图片分组列表
    getGroupLists (store, params) {
      return getGroupLists(params)
    },
    //-----------------------------视频-------------------------------
    // 获取视频素材列表
    getVideoList (store, params) {
      return getVideoList(params)
    },
    // 删除视频列表
    delVideo (store, params) {
      return delVideo(params)
    },
    // 修改视频列表详情
    editVideo (store, {id, params}) {
      return editVideo(id, params)
    },
    // 获取视频详情
    getVideoDetail (store, {id, params}) {
      return getVideoDetail(id, params)
    },
    // 获取视频分类列表
    getVideoCategoryList (store, params) {
      return getVideoCategoryList(params)
    },
    // 添加视频分类
    addVideoCategory (store, params) {
      return addVideoCategory(params)
    },
    //修改视频分类
    editVideoCategory (store, {id, params}) {
      return editVideoCategory(id, params)
    },
    //删除视频分类
    delVideoCategory (store, params) {
      return delVideoCategory(params)
    },
    // 获取视频分组列表
    getVideoGroupList (store, params) {
      return getVideoGroupList(params)
    },
    //删除视频分组
    delVideoGroup (store, params) {
      return delVideoGroup(params)
    },

    // 修改视频分组
    editVideoGroup (store, {id, params}) {
      return editVideoGroup(id, params)
    },
    // 获取视频分组列表
    addVideoGroup (store, params) {
      return addVideoGroup(params)
    },
    //-----------------------------文章-------------------------------
    // 渲染文章列表页
    getArticle (store, params) {
      return getArticle(params)
    },
    // 添加文章
    AddArticle (store, params) {
      return AddArticle(params)
    },

    // 编辑海报
    editArticle (store, {id, params}) {
      return editArticle(id, params)
    },
    // 获取海报详情
    getArticleDetail (store, {id, params}) {
      return getArticleDetail(id, params)
    },

    // 删除海报素材
    delArticle (store, params) {
      return delArticle(params)
    },

    // 渲染分类
    getArticleCategory (store, params) {
      return getArticleCategory(params)
    },
    // 渲染分组
    getArticleGroup (store, params) {
      return getArticleGroup(params)
    },
    // 添加分类
    addArticleCategory (store, params) {
      return addArticleCategory(params)
    },
    //添加分组
    addArticleGroup (store, params) {
      return addArticleGroup(params)
    },
    //修改文章分类
    redactArticleCategory (store, {id, params}) {
      return redactArticleCategory(id, params)
    },
    //修改文章分类
    redactArticleGroup (store, {id, params}) {
      return redactArticleGroup(id, params)
    },
    // 分类删除
    delArticleCategory (store, params) {
      return delArticleCategory(params)
    },
    // 分组删除
    delArticleGroup (store, params) {
      return delArticleGroup(params)
    },
    //-----------------------------商品-------------------------------
    // 渲染商品列表页
    getGoods (store, params) {
      return getGoods(params)
    },
    // 渲染分类
    getGoodsCategory (store, params) {
      return getGoodsCategory(params)
    },
    // 渲染分组
    getGoodsGroup (store, params) {
      return getGoodsGroup(params)
    },
    // 添加分类
    addGoodsCategory (store, params) {
      return addGoodsCategory(params)
    },
    //添加分组
    addGoodsGroup (store, params) {
      return addGoodsGroup(params)
    },
    //修改分类
    redactGoodsCategory (store, {id, params}) {
      return redactGoodsCategory(id, params)
    },
    //修改分组
    redactGoodsGroup (store, {id, params}) {
      return redactGoodsGroup(id, params)
    },
    // 分类删除
    delGoodsCategory (store, params) {
      return delGoodsCategory(params)
    },
    // 分组删除
    delGoodsGroup (store, params) {
      return delGoodsGroup(params)
    },
    addGoods (store, params) {
      return addGoods(params)
    },
    editGood (store, {id, params}) {
      return editGoods(id, params)
    },
    editItemGood(store, {id, params}) {
      return editItemGoods(id, params)
    },
    getGoodDetail (store, id) {
      return getGoodDetail(id)
    },
    delGood (store, params) {
      return delGood(params)
    },
    //-----------------------------海报-------------------------------
    // 渲染列表页
    getPoster (store, params) {
      return getPoster(params)
    },
    // 添加海报
    getAddPoster (store, params) {
      return getAddPoster(params)
    },
    // 编辑海报
    editPoster (store, {id, params}) {
      return editPoster(id, params)
    },
    // 获取海报详情
    getPosterDetail (store, {id, params}) {
      return getPosterDetail(id, params)
    },

    // 删除海报素材
    delPoster (store, params) {
      return delPoster(params)
    },
    // 渲染分类
    getPosterCategory (store, params) {
      return getPosterCategory(params)
    },
    // 渲染分组
    getPosterGroup (store, params) {
      return getPosterGroup(params)
    },
    // 添加分类
    addPosterCategory (store, params) {
      return addPosterCategory(params)
    },
    //添加分组
    addPosterGroup (store, params) {
      return addPosterGroup(params)
    },
    //修改文章分类
    redactPosterCategory (store, {id, params}) {
      return redactPosterCategory(id, params)
    },
    //修改文章分组
    redactPosterGroup (store, {id, params}) {
      return redactPosterGroup(id, params)
    },
    // 分类删除
    delPosterCategory (store, params) {
      return delPosterCategory(params)
    },
    // 分组删除
    delPosterGroup (store, params) {
      return delPosterGroup(params)
    },

    //-----------------------------名片-------------------------------
    // 渲染列表页
    getBuscard (store, params) {
      return getBuscard(params)
    },
    // 添加名片
    addBuscard (store, params) {
      return addBuscard(params)
    },
    // 编辑名片
    editBuscard (store, {id, params}) {
      return editBuscard(id, params)
    },
    // 获取名片详情
    getBuscardDetail (store, {id, params}) {
      return getBuscardDetail(id, params)
    },

    // 删除名片素材
    delBuscard (store, params) {
      return delBuscard(params)
    },
    // 渲染分类
    getBuscardCategory (store, params) {
      return getBuscardCategory(params)
    },
    // 渲染分组
    getBuscardGroup (store, params) {
      return getBuscardGroup(params)
    },
    // 添加分类
    addBuscardCategory (store, params) {
      return addBuscardCategory(params)
    },
    //添加分组
    addBuscardGroup (store, params) {
      return addBuscardGroup(params)
    },
    //修改文章分类
    redactBuscardCategory (store, {id, params}) {
      return redactBuscardCategory(id, params)
    },
    //修改文章分类
    redactBuscardGroup (store, {id, params}) {
      return redactBuscardGroup(id, params)
    },
    // 分类删除
    delBuscardCategory (store, params) {
      return delBuscardCategory(params)
    },
    // 分组删除
    delBuscardGroup (store, params) {
      return delBuscardGroup(params)
    },

    //-----------------------------手册-------------------------------
    // 渲染列表页
    getHandBook (store, params) {
      return getHandBook(params)
    },
    // 添加手册
    getAddHandBook (store, params) {
      return getAddHandBook(params)
    },
    // 编辑手册
    editHandBook (store, {id, params}) {
      return editHandBook(id, params)
    },

    // 获取详情
    getHandBookDetail (store, {id, params}) {
      return getHandBookDetail(id, params)
    },

    // 删除素材
    delHandBook (store, params) {
      return delHandBook(params)
    },

    // 渲染分类
    getHandBookCategory (store, params) {
      return getHandBookCategory(params)
    },

    // 渲染分组
    getHandBookGroup (store, params) {
      return getHandBookGroup(params)
    },
    // 添加分类
    addHandBookCategory (store, params) {
      return addHandBookCategory(params)
    },
    //添加分组
    addHandBookGroup (store, params) {
      return addHandBookGroup(params)
    },

    //修改分类
    redactHandBookCategory (store, {id, params}) {
      return redactHandBookCategory(id, params)
    },
    //修改分组
    redactHandBookGroup (store, {id, params}) {
      return redactHandBookGroup(id, params)
    },
    // 分类删除
    delHandBookCategory (store, params) {
      return delHandBookCategory(params)
    },
    // 分组删除
    delHandBookGroup (store, params) {
      return delHandBookGroup(params)
    },

    //-----------------------------文档-------------------------------
    // 渲染列表页
    getDocument (store, params) {
      return getDocument(params)
    },
    // 添加文档
    AddDocument (store, params) {
      return AddDocument(params)
    },
    // 编辑文档
    editDocument (store, {id, params}) {
      return editDocument(id, params)
    },

    // 获取详情
    getDocumentDetail (store, {id, params}) {
      return getDocumentDetail(id, params)
    },

    // 删除素材
    delDocument (store, params) {
      return delDocument(params)
    },

    // 渲染分类
    getDocumentCategory (store, params) {
      return getDocumentCategory(params)
    },

    // 渲染分组
    getDocumentGroup (store, params) {
      return getDocumentGroup(params)
    },
    // 添加分类
    addDocumentCategory (store, params) {
      return addDocumentCategory(params)
    },
    //添加分组
    addDocumentGroup (store, params) {
      return addDocumentGroup(params)
    },

    //修改分类
    redactDocumentCategory (store, {id, params}) {
      return redactDocumentCategory(id, params)
    },
    //修改分组
    redactDocumentGroup (store, {id, params}) {
      return redactDocumentGroup(id, params)
    },
    // 分类删除
    delDocumentCategory (store, params) {
      return delDocumentCategory(params)
    },
    // 分组删除
    delDocumentGroup (store, params) {
      return delDocumentGroup(params)
    },
    //-----------------------------导航-------------------------------
// 渲染列表页

    getLocation (store, params) {
      return getLocation(params)
    },
    // 添加导航
    AddLocation (store, params) {
      return AddLocation(params)
    },
    // 编辑导航
    editLocation (store, {id, params}) {
      return editLocation(id, params)
    },

    // 获取详情
    getLocationDetail (store, {id, params}) {
      return getLocationDetail(id, params)
    },

    // 删除素材
    delLocation (store, params) {
      return delLocation(params)
    },

    //-----------------------------渲染-------------------------------
    // 渲染列表页
    getBbs (store, params) {
      return getBbs(params)
    },
    // 添加渲染
    AddBbs (store, params) {
      return AddBbs(params)
    },
    // 获取详情
    getBbsDetail (store, {id, params}) {
      return getBbsDetail(id, params)
    },

    // 删除素材
    delBbs (store, {id, params}) {
      return delBbs(id, params)
    },

    //------------------------------------------------------------
    // 渲染列表页
    getComment (store, params) {
      return getComment(params)
    },
    delComments (store, {id, params}) {
      return delComment(id, params)
    },
    //-----------------------------分类分组-------------------------------
    // 渲染分类
    getCategory (store, params) {
      return getCategory(params)
    },

    // 渲染分组
    getGroup (store, params) {
      return getGroup(params)
    },
    // 添加分类
    addCategories (store, params) {
      return addCategories(params)
    },
    //添加分组
    postAddGroupes (store, params) {
      return postAddGroupes(params)
    },

    //修改分类
    redactCategorisy (store, {id, params}) {
      return redactCategorisy(id, params)
    },
    //修改分组
    redactGroupes (store, {id, params}) {
      return redactGroupes(id, params)
    },
    // 分类删除
    delCategories (store, params) {
      return delCategories(params)
    },
    // 分组删除
    delGroupes (store, params) {
      return delGroupes(params)
    },
    pdfToPic (store, params) {
      return pdfToPic(params)
    },
    getPdfToPisList (store, uploadId) {
      return getPdfToPisList(uploadId)
    }
  }

}

